/**
 * Keeps high-count volleys readable without removing logical projectiles.
 * Hidden bullets still move and collide; this only controls their sprite.
 */
export function getProjectileVisualStride(soldierCount: number): number {
  if (soldierCount <= 18) return 1;
  if (soldierCount <= 36) return 2;
  if (soldierCount <= 72) return 3;
  if (soldierCount <= 120) return 5;
  if (soldierCount <= 180) return 7;
  return 9;
}
